var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"job-queue"}},[(!_vm.jobQueueLoadingState)?[_vm._m(0),_c('div',{staticClass:"inner-quality__content"},[_c('JobQueueTable')],1)]:_c('content-spinner',{attrs:{"show":_vm.jobQueueLoadingState}})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toolbar-wrapper"},[_c('h4',[_vm._v("Job Queue")])])
}]

export { render, staticRenderFns }